// Importing Vue
import Vue from "vue";

// Assign it to Global Variable
window.Vue = Vue;

import Vuex from "vuex";
// Tell vue to use vuex
Vue.use(Vuex);

// Import Vue Router
import VueRouter from "vue-router";

//Importing Vee Validation
import VeeValidate from "vee-validate";

//Tell Vue to use the Vee Validation
Vue.use(VeeValidate);
//Import Jquery
import jquery from "jquery";

//window.$ = window.jQuery = jquery;

// Assign it to Globarl Variable
window.VueRouter = VueRouter;

// Tell Vue to use Vue router
Vue.use(VueRouter);
//Add Vuex

// Import OnBlick UI
// import OnBlickUI from './components/VueStyleGuide/index.js';
import OnBlickUI from "onblick_ui_component_library/src/index.js";
import TextHighlight from 'vue-text-highlight';
Vue.component('text-highlight', TextHighlight);


// Tell Vue to use OnBlick UI
Vue.use(OnBlickUI);

Vue.prototype.$alert2 = require("./components/MovedFromVueStyleGuide/MessageBox/index.js").default;
// Import lodash
import _ from "lodash";

window.__ = _.noConflict();

// Import moment
import moment from "moment";
window.moment = moment;

import PosthogPlugin from './postHog.js'
Vue.use(PosthogPlugin)

// Require Event API
require("./components/Core/event-api.js");

// Require ajax
require("./components/Core/ajax.js");

// Require Global Filters
require("./components/Core/filters.js");

// Require Global Directives
require("./components/Core/directives.js");

// Vue.component('spinner', () => import('./Components/Spinner.vue'));

// Vue.component('modal', () => import('./Components/Modal.vue'));

// Vue.component('select2', () => import('./Components/Select2.vue'));

// Vue.component('contactcircle', () => import('./Components/ContactCircle.vue'));

// // Vue.component('tinymce', () => import('./Components/tinymce.vue'));

// Vue.component('template-comp', () => import('./Components/TemplateComponent.vue'));

Vue.component("location-search", () =>
  import("./components/GlobalComponent/Location.vue")
);

// Base Layout component

import BaseLayout from "@/components/BaseLayout.vue";
Vue.component("base-layout", BaseLayout);

// Migrated from Vue Style Guide

Vue.component("ob-dynamic-form-fields-ess", () =>
  import("./components/MovedFromVueStyleGuide/DynamicFormFields/index.js")
);

Vue.component("ob-document-list-ess", () =>
  import("./components/MovedFromVueStyleGuide/DocumentList/index.js")
);

Vue.component("ob-ead-document", () =>
  import("./components/MovedFromVueStyleGuide/EadDocument/index.js")
);

Vue.component("ob-l1visa-document", () => 
  import("./components/MovedFromVueStyleGuide/L1E3TNVisaDocument/index.js")
);



Vue.component("ob-projects-upload-document-group-ess", () =>
  import(
    "./components/MovedFromVueStyleGuide/ProjectsUploadDocumentGroup/index.js"
  )
);
Vue.component("ob-timesheet-status-progress", () =>
  import("./components/GlobalComponent/DraggableTimesheetProgress.vue")
);
Vue.component("draggable", () => import("vuedraggable"));
Vue.component("popover-list", () =>
  import("./components/ESSProfile/Tasks/PopOverList.vue")
);



// WEBPACK FOOTER //
// ./src/bootstrap.js